import { useAutocomplete } from 'admin';
import type { SimpleSite } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SimpleSite>, 'options' | 'defaultValue'> & {
  tradeCompanyId?: number;
  defaultValue?: SimpleSite['id'];
};

export const TradeCompanySiteSelector = ({ tradeCompanyId, required = false, defaultValue, ...rest }: Props) => {
  const { autocompleteProps } = useAutocomplete<SimpleSite>({
    dataProviderName: 'trade',
    defaultValue,
    queryOptions: {
      enabled: Boolean(tradeCompanyId),
    },
    resource: `/v1/trade-companies/${tradeCompanyId}/trade-sites/`,
  });
  return (
    <AutocompleteField<SimpleSite>
      {...autocompleteProps}
      data-testid="trade-site-selector"
      disabled={Boolean(!tradeCompanyId)}
      getOptionLabel={(item) => {
        if (!item.full_address) {
          return '';
        }
        return item.full_address;
      }}
      valueField="id"
      required={required}
      {...rest}
    />
  );
};
